import WasteTab from "@/components/WasteTab";
import { PackageX } from "lucide-react";

export default function Waste() {
  return (
    <div className="space-y-5 fade-in" data-testid="waste-page">
      <div>
        <h1 className="flex items-center gap-2 font-heading text-2xl font-black tracking-tight text-slate-900">
          <PackageX className="h-6 w-6 text-red-500" /> Fire / Zayiat
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Bozulan, kırılan veya son kullanma tarihi geçen ürünleri kaydedin. Kayıt <b>muhasebe onayına</b> düşer;
          onaylanınca stoktan düşülür, sorumlunun <b>puanı</b> etkilenir ve yönetime bildirim gider.
        </p>
      </div>
      <WasteTab />
    </div>
  );
}
